import {useUserPref} from '@netx/core-components/hooks/useUserPref';
import {SearchVisualPref} from '../constants';

export const useIsVisualSearchEnabled = () => {
	const [visualEnabled] = useUserPref(SearchVisualPref.ENABLED, {
		asBoolean: true,
	});

	return visualEnabled;
};

export default useIsVisualSearchEnabled;
